import React from 'react';

const WhiteEdit = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <circle cx='10' cy='10' r='10' fill='white' />
            <path
                d='M13.9253 8.53958L11.4462 6.08958L12.2628 5.27292C12.4864 5.04931 12.7612 4.9375 13.0871 4.9375C13.413 4.9375 13.6875 5.04931 13.9107 5.27292L14.7274 6.08958C14.951 6.31319 15.0677 6.58308 15.0774 6.89925C15.0871 7.21542 14.9802 7.48511 14.7566 7.70833L13.9253 8.53958ZM5.00033 15.5833C4.83505 15.5833 4.69641 15.5273 4.58441 15.4153C4.47241 15.3033 4.41661 15.1649 4.41699 15V13.3521C4.41699 13.2743 4.43158 13.1989 4.46074 13.1258C4.48991 13.0526 4.53366 12.9871 4.59199 12.9292L10.6003 6.92083L13.0795 9.4L7.07116 15.4083C7.01283 15.4667 6.9473 15.5104 6.87458 15.5396C6.80186 15.5687 6.72641 15.5833 6.64824 15.5833H5.00033Z'
                fill='black'
            />
        </svg>
    );
};

export default WhiteEdit;
